// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as AddGemExtended } from '../../../../../ui-v3/src/assets/icons/extended/custom3.0/add-gem.svg?react';
import { createIcons } from '../../Icon';
const AddGemIcon = /* @__PURE__ */ createIcons('AddGem', {
    extended: AddGemExtended
});
AddGemIcon.supportedTypes = [
    'extended'
];
AddGemIcon.category = 'custom3.0';
export default AddGemIcon;
